module.exports = __webpack_public_path__ + "static/img/polystyrene-box.8695eb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/package-service/polystyrene-box.png
// module id = aXBW
// module chunks = 2